const a = "{{currentTime}} i roto i te {{duration}}", t = "Hua rapu {{current}} o te {{total}}", n = "Kāore he hua i kitea", o = "{{count}} hua i kitea", e = "{{count}} ngā hua kua kitea", T = 'Te purei mai i $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) me $t(SECONDS, { "count": {{seconds}} }).', i = 'Te purei mai i $t(MINUTES, { "count": {{minutes}} }) me $t(SECONDS, { "count": {{seconds}} }).', A = 'Te purei mai i $t(SECONDS, { "count": {{seconds}} }).', E = "I hapa te tiaki i ngā huringa ki te tuhinga.", u = "Raina tuhinga kei {{time}}. Ko te ihirangi: {{text}}.", c = 'Ipu rārangi tuhinga. I reira $t(TRANSCRIPT_LINES, { "count": {{count}} }) roto i tēnei ipu. Whakamahia te pere ki raro hei tirotiro i roto i tenei ipu.', _ = "Tiaki huringa...", s = "Kua tiakina ngā huringa ki te tuhinga.", S = "Kei te wātea inaianei te pātene whakahou taitara.", R = "Mahi", N = "Taapirihia he korero ki {{time}}", h = "Tāpiri pātai ki {{time}}", r = "Ngā tuhipoka", I = "Aunoa", O = "Aunoa ({{quality}})", P = "Hoki", C = "Ngā tapanga", g = "Reo Tapanga", k = "Whakahere ngā tapanga", U = "Muku {{language}}", L = "Rahi Momotuhi", p = "Reo Tapanga: {{language}}", M = "{{language}} (aunoa)", D = "Mukua te Rapu", m = "Katia", G = "Ngā kōrero", K = "Tonu", Y = "Whakahekea Tere Whakahoki", H = "Whakaheke Rōrahi mā {{percent}}%", W = "Pere raro", V = "Katia te Etita Tuhinga", B = "Whakahōu i ngā Taitara", w = "He hapa!", F = "Kei te whakaoratia ...", d = "Ora!", l = "Whakatikahia te tuhinga", $ = "Kāore e taea te noho kau te tuhinga!", Q = "Mata katoa", J = "{{count}} haora", x = "{{count}} haora", Z = "Whakanuia te Tere purei", X = "Whakanuia te Rōrahi mā {{percent}}%", f = "Hurihia nga Tae", q = "Peke ki te ōrau motuhake (1-10%, 2-20%, aha atu)", v = "Peke ki te Tīmata", y = "Ngā mahi mō {{title}}", b = "Pokatata papapātuhi", j = "reo", z = "Pere Maui", aa = "Tahua Matua", ta = "{{count}} meneti", na = "{{count}} meneti", oa = "Kua Ngū", ea = "Kua ngū", Ta = "Te Reo Tapanga Panuku", ia = "Hua rapunga e whai ake nei", Aa = "Weto", Ea = "Kei Runga", ua = "Whakatuwherahia te tuhipoka i {{time}}", ca = "Tuwherahia te patapatai kua oti i {{time}}", _a = "Tuwhera te patapatai i {{time}}", sa = "Okioki", Sa = "Tākaro", Ra = "Te rere o te mahi anō", Na = "Tere purei: {{speed}}x", ha = "Te Reo Tapanga o mua", ra = "Hua rapunga o mua", Ia = "Kounga", Oa = "Tahua Kounga", Pa = "Tākaro anō", Ca = "Tautuhi Anō Te Tere Purei", ga = "Pere Matau", ka = "Rapu i roto i te tuhinga", Ua = "{{count}} tuarua", La = "{{count}} ngā hēkona", pa = "Rapua whakamuri: {{seconds}} ngā hēkona", Ma = "Rapua whakamua: {{seconds}} ngā hēkona", Da = "Ngā Tautuhinga", ma = "Pokatata", Ga = "Ngā taipitopito pāpāho me ngā taputapu", Ka = "Mokowā", Ya = "Tahua tere purei", Ha = "Tīmatahia te Panuku Aunoa", Wa = "Nga Takahuri Tapanga", Va = "Takahuri Wahangu", Ba = "Takahuri Purei/Tatari", wa = "he rārangi tuhinga {{count}} tēnei", Fa = "he rārangi tuhinga {{count}} ēnei", da = "E utaina ana te tuhinga...", la = "Kāore i taea te uta i te tuhinga.", $a = "Ngā Kōwhiringa Tuhinga", Qa = "Ngana ano", Ja = "Kāore e wātea ana te tuhinga", xa = "Pere Runga", Za = "Tautuhinga Ataata", Xa = "Te nuinga", fa = "Rōrahi: {{volume}}%", qa = {
  A11Y_DURATION: a,
  A11Y_SEARCH_HITS: t,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: e,
  A11Y_TIMESTAMP_JUMP_HOURS: T,
  A11Y_TIMESTAMP_JUMP_MINUTES: i,
  A11Y_TIMESTAMP_JUMP_SECONDS: A,
  A11Y_TRANSCRIPT_ERROR: E,
  A11Y_TRANSCRIPT_LINE: u,
  A11Y_TRANSCRIPT_LINES: c,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: s,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: S,
  ACTION: R,
  ADD_ANNOTATION_AT: N,
  ADD_QUESTION_AT: h,
  ANNOTATIONS: r,
  AUTO: I,
  AUTO_QUALITY: O,
  BACK: P,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: g,
  CAPTIONS_MANAGE: k,
  CAPTION_DELETE: U,
  CAPTION_FONT_SIZE: L,
  CAPTION_LANGUAGE: p,
  CAPTION_LANGUAGE_AUTOMATIC: M,
  CLEAR_SEARCH: D,
  CLOSE: m,
  COMMENTS: G,
  CONTINUE: K,
  DECREASE_PLAYBACK_SPEED: Y,
  DECREASE_VOLUME: H,
  DOWN_ARROW: W,
  EDIT_CLOSE: V,
  EDIT_CONFIRM: B,
  EDIT_ERROR: w,
  EDIT_SAVING: F,
  EDIT_SUCCESS: d,
  EDIT_TRANSCRIPT: l,
  EDIT_VALIDATION_ERROR: $,
  FULLSCREEN: Q,
  HOURS: J,
  HOURS_other: x,
  INCREASE_PLAYBACK_SPEED: Z,
  INCREASE_VOLUME: X,
  INVERT_COLORS: f,
  JUMP_TO_PERCENTAGE: q,
  JUMP_TO_START: v,
  KEBAB_MENU: y,
  KEYBOARD_SHORTCUTS: b,
  LANGUAGE: j,
  LEFT_ARROW: z,
  MAIN_MENU: aa,
  MINUTES: ta,
  MINUTES_other: na,
  MUTE: oa,
  MUTED: ea,
  NEXT_CAPTION_LANGUAGE: Ta,
  NEXT_HIT: ia,
  OFF: Aa,
  ON_TOP: Ea,
  OPEN_ANNOTATION_AT: ua,
  OPEN_COMPLETED_QUIZ_AT: ca,
  OPEN_QUIZ_AT: _a,
  PAUSE: sa,
  PLAY: Sa,
  PLAYBACK_SPEED: Ra,
  PLAYBACK_SPEED_MESSAGE: Na,
  PREVIOUS_CAPTION_LANGUAGE: ha,
  PREVIOUS_HIT: ra,
  QUALITY: Ia,
  QUALITY_MENU: Oa,
  REPLAY: Pa,
  RESET_PLAYBACK_SPEED: Ca,
  RIGHT_ARROW: ga,
  SEARCH_TRANSCRIPT_PLACEHOLDER: ka,
  SECONDS: Ua,
  SECONDS_other: La,
  SEEK_BACKWARD: pa,
  SEEK_FORWARD: Ma,
  SETTINGS: Da,
  SHORTCUT: ma,
  SIDEBAR: Ga,
  SPACE: Ka,
  SPEED_MENU: Ya,
  START_AUTOSCROLL: Ha,
  TOGGLE_CAPTIONS: Wa,
  TOGGLE_MUTED: Va,
  TOGGLE_PLAY_PAUSE: Ba,
  TRANSCRIPT_LINES: wa,
  TRANSCRIPT_LINES_other: Fa,
  TRANSCRIPT_LOADING: da,
  TRANSCRIPT_LOAD_ERROR: la,
  TRANSCRIPT_OPTIONS: $a,
  TRANSCRIPT_RETRY: Qa,
  TRANSCRIPT_UNAVAILABLE: Ja,
  UP_ARROW: xa,
  VIDEO_SETTINGS: Za,
  VOLUME: Xa,
  VOLUME_VALUE: fa
};
export {
  a as A11Y_DURATION,
  t as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  e as A11Y_SEARCH_RESULTS_FOUND_other,
  T as A11Y_TIMESTAMP_JUMP_HOURS,
  i as A11Y_TIMESTAMP_JUMP_MINUTES,
  A as A11Y_TIMESTAMP_JUMP_SECONDS,
  E as A11Y_TRANSCRIPT_ERROR,
  u as A11Y_TRANSCRIPT_LINE,
  c as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  s as A11Y_TRANSCRIPT_SUCCESS,
  S as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  R as ACTION,
  N as ADD_ANNOTATION_AT,
  h as ADD_QUESTION_AT,
  r as ANNOTATIONS,
  I as AUTO,
  O as AUTO_QUALITY,
  P as BACK,
  C as CAPTIONS,
  g as CAPTIONS_LANGUAGE,
  k as CAPTIONS_MANAGE,
  U as CAPTION_DELETE,
  L as CAPTION_FONT_SIZE,
  p as CAPTION_LANGUAGE,
  M as CAPTION_LANGUAGE_AUTOMATIC,
  D as CLEAR_SEARCH,
  m as CLOSE,
  G as COMMENTS,
  K as CONTINUE,
  Y as DECREASE_PLAYBACK_SPEED,
  H as DECREASE_VOLUME,
  W as DOWN_ARROW,
  V as EDIT_CLOSE,
  B as EDIT_CONFIRM,
  w as EDIT_ERROR,
  F as EDIT_SAVING,
  d as EDIT_SUCCESS,
  l as EDIT_TRANSCRIPT,
  $ as EDIT_VALIDATION_ERROR,
  Q as FULLSCREEN,
  J as HOURS,
  x as HOURS_other,
  Z as INCREASE_PLAYBACK_SPEED,
  X as INCREASE_VOLUME,
  f as INVERT_COLORS,
  q as JUMP_TO_PERCENTAGE,
  v as JUMP_TO_START,
  y as KEBAB_MENU,
  b as KEYBOARD_SHORTCUTS,
  j as LANGUAGE,
  z as LEFT_ARROW,
  aa as MAIN_MENU,
  ta as MINUTES,
  na as MINUTES_other,
  oa as MUTE,
  ea as MUTED,
  Ta as NEXT_CAPTION_LANGUAGE,
  ia as NEXT_HIT,
  Aa as OFF,
  Ea as ON_TOP,
  ua as OPEN_ANNOTATION_AT,
  ca as OPEN_COMPLETED_QUIZ_AT,
  _a as OPEN_QUIZ_AT,
  sa as PAUSE,
  Sa as PLAY,
  Ra as PLAYBACK_SPEED,
  Na as PLAYBACK_SPEED_MESSAGE,
  ha as PREVIOUS_CAPTION_LANGUAGE,
  ra as PREVIOUS_HIT,
  Ia as QUALITY,
  Oa as QUALITY_MENU,
  Pa as REPLAY,
  Ca as RESET_PLAYBACK_SPEED,
  ga as RIGHT_ARROW,
  ka as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ua as SECONDS,
  La as SECONDS_other,
  pa as SEEK_BACKWARD,
  Ma as SEEK_FORWARD,
  Da as SETTINGS,
  ma as SHORTCUT,
  Ga as SIDEBAR,
  Ka as SPACE,
  Ya as SPEED_MENU,
  Ha as START_AUTOSCROLL,
  Wa as TOGGLE_CAPTIONS,
  Va as TOGGLE_MUTED,
  Ba as TOGGLE_PLAY_PAUSE,
  wa as TRANSCRIPT_LINES,
  Fa as TRANSCRIPT_LINES_other,
  da as TRANSCRIPT_LOADING,
  la as TRANSCRIPT_LOAD_ERROR,
  $a as TRANSCRIPT_OPTIONS,
  Qa as TRANSCRIPT_RETRY,
  Ja as TRANSCRIPT_UNAVAILABLE,
  xa as UP_ARROW,
  Za as VIDEO_SETTINGS,
  Xa as VOLUME,
  fa as VOLUME_VALUE,
  qa as default
};
